import React from "react";

export function JetsDeliveryIcon(): React.ReactElement {
  return (
    <svg
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      height="64"
      width="64"
    >
      <g transform="matrix(0.6262289881706238, 0, 0, 0.6262289881706238, -88.67325592041013, -88.779296875)">
        <ellipse
          cx="859.5"
          cy="702"
          rx="40.5"
          ry="57"
          fill="#fff"
          strokeWidth="0px"
        />
        <path
          d="m716.5,702h-459c-12.9-19.56-31.82-54.14-38.5-101.12-12.47-87.68,26.75-154.81,38.5-173.43,43.76-15.62,108.33-36.24,188.5-41.39,118.36-7.61,213.53,19.71,270.5,41.39,68.36,22,110.46,90.66,101.5,157.71-7.29,54.52-47.37,100.75-101.5,116.84Z"
          fill="#fff"
          strokeWidth="0px"
        />
        <path
          d="m185.19,708.19h-1.52c-16.78,0-30.33-13.7-30.15-30.47l1.43-135.16c2.79-16.77,13.6-30.99,28.83-38.54,35.81-17.76,51.11-60.8,73.67-78.18,30.46-23.46,47.96-31.05,113.54-32.53h12.85"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m405.62,446.53c4.76,1.02,9.38,2.55,13.81,4.54,38.26,17.25,72.43,47.23,88.12,72.95,5.91,9.69,1.97,27.08-6.18,27.15-38.16.34-126.88.26-189.87-5.72-46.32-4.4-76.82-27.43-76.82-27.43,0,0,27.91-73.32,97.37-76.5,38.72-1.77,61.39,2.4,73.56,5.01Z"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <line
          x1="282.52"
          y1="708.19"
          x2="537.5"
          y2="708.19"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m636.91,687.56c0,39.64-22.25,71.77-49.7,71.77s-49.71-32.14-49.71-71.77,22.25-71.77,49.71-71.77,49.7,32.13,49.7,71.77Z"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m284.6,687.56c0,39.64-22.25,71.77-49.7,71.77s-49.71-32.14-49.71-71.77,22.25-71.77,49.71-71.77,49.7,32.13,49.7,71.77Z"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m823.15,519.95c-48.94-43.73-104.37-126.65-186.24-126.65-93.87-2.38-253.06,0-253.06,0"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m383.84,393.3c77.1,0,130.77,73.55,177.63,118.64,5.36,5.16,12.53,8,19.97,8h241.71"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m823.15,519.95s38.06,10.63,54.05,17.65c23.56,10.35,40.25,23.7,44.52,49.07,2.26,13.42,4.23,25.93,4.69,41.47.28,9.67-.37,36.05,0,56.36.24,13.01-8.38,23.68-21.4,23.68h-270.18"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m851.95,759.34c-22.49,0-41.49-21.56-47.62-51.15"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m904.78,708.19c-6.14,29.58-25.13,51.15-47.62,51.15"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <line
          x1="842.48"
          y1="644.62"
          x2="759.36"
          y2="644.62"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m876.71,615.08c9.02,0,31.96,3.23,45.99-22.47"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <path
          d="m716.98,615.08c-13.09,0-47.75,3.67-66.23-28.04"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
        <line
          x1="369.21"
          y1="534.79"
          x2="369.21"
          y2="441.49"
          fill="#fff"
          stroke="rgb(0,146,69)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="17px"
        />
      </g>
      <path
        d="M 264.514 153.671 L 251.619 120.744 C 243.353 117.049 226.739 110.963 205.222 112.19 C 186.523 113.254 172.376 119.373 164.605 123.444 C 162.112 132.612 159.62 141.773 157.127 150.941"
        fill="#fff"
        stroke="rgb(0,146,69)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="17px"
      />
    </svg>
  );
}
